import { useState } from "react";
import { Button, IconProvider } from "../ui";

interface SubscribeStep2Props {
  email: string;
  onNext: (selectedOptions: string[]) => void;
}

const SubscribeStep3: React.FC<SubscribeStep2Props> = ({ email, onNext }) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  const selectOptions = [
    { label: "Localization", value: "localization" },
    { label: "Translation", value: "translation" },
    { label: "Game Development", value: "game-development" },
    { label: "Structuring our games", value: "structuring-games" },
    { label: "Be Engine Agnostic", value: "become-engine-agnostic" },
    { label: "Documentation", value: "documentation" },
    { label: "Writing", value: "writing" },
    { label: "QA Testing", value: "qa-testing" },
    { label: "Data Collection", value: "data-collection" },
    { label: "Do not know yet", value: "do-not-know" },
  ];

  const handleOptionToggle = (value: string) => {
    setSelectedOptions((prev) =>
      prev.includes(value)
        ? prev.filter((option) => option !== value)
        : [...prev, value]
    );
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onNext(selectedOptions);
  };

  return (
    <>
      <h2 className="text-xl font-bold text-left text-gray-900 ">
        What do you want to use LocaNest for?
      </h2>
      <p className="text-sm text-gray-900 pb-2">
        (You can select multiple options)
      </p>

      <div className="flex flex-col gap-6 w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {selectOptions.map((option) => (
            <Button
              key={option.value}
              variant="toggleCheck"
              isChecked={selectedOptions.includes(option.value)}
              onToggle={() => handleOptionToggle(option.value)}
              className="h-12 text-sm"
            >
              {option.label}
            </Button>
          ))}
        </div>

        <div className="flex justify-center mt-4">
          <Button
            variant="default"
            onClick={handleSubmit}
            className="w-full mt-4"
            disabled={selectedOptions.length === 0}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};
export default SubscribeStep3;
